import React, { useCallback, useMemo, useState } from 'react'
import { AppTitlePage } from '../../../components/AppTitlePage'
import { AppBtnColor } from '../../../components/btn/AppBtn'
import { AppTable } from '../../../components/AppTable/AppTable'
import { IChooseItems } from '../../../components/mainContent/TableAllDishes'
import { useGetCategoryQuery } from '../../../core/api/CategoryApi'
import { useParamsControl } from '../../../utils/useParamsControl'
import {
  ICategoriesRequestDto,
  ICategory,
} from '../../../core/api/dto/CategoriesObjDto'
import { AppFilterInput } from '../../../components/AppInput/AppFilterInput'
import { AddCategoryPopup } from './AddCategoryPopup'
import { AppLoader, LoaderType } from 'components/AppLoader'
import { AppDeleteFromMainServerPopup } from '../../../entities/AppDeleteFromMainServerPopup/AppDeleteFromMainServerPopup'
import { AppStationPopup } from '../../../entities/AppStationPopup/AppStationPopup'
import { useSentCategoryOnFotobox } from './hooks/useSentCategoryOnFotobox'
import { useDeleteCategory } from './hooks/useDeleteCategory'
import { AppFilterEdgeServersList } from '../../../entities/AppFilterEdgeServersList/AppFilterEdgeServersList'

const headerData = [{ title: 'Категория', colWidth: '95%', sort: 'name' }]

export interface IPopup {
  active: boolean
  id: number | null
}

export const CategoriesPage = () => {
  const pageParams = useParamsControl<
    ICategoriesRequestDto,
    keyof ICategoriesRequestDto
  >({
    withPagination: true,
    whiteList: ['search', 'ordering', 'edge_servers'],
  })
  const {
    data: category,
    isLoading: isLoadingGet,
    isFetching: isFetchingGet,
  } = useGetCategoryQuery(
    { ...pageParams },
    {
      skip: !pageParams,
    },
  )
  const [openCreatePopup, setOpenCreatePopup] = useState<IPopup>({
    active: false,
    id: null,
  })
  const [chooseItems, setChooseItems] = useState<IChooseItems | null>(null)
  const [tableData, setTableData] = useState<ICategory[]>([])

  const {
    deleteStations,
    isDeleteMode,
    onDeleteStation,
    isLoadingSend,
    onSendCategories,
    openDeleteStationPopup,
    openSentPopup,
    sentPopup,
    closeSentPopup,
  } = useSentCategoryOnFotobox({
    tableData,
    chooseItems,
    setChooseItems,
  })
  const {
    deletePopup,
    onDeletePopupHandler,
    onDeleteHandler,
    closeDeletePopup,
  } = useDeleteCategory(chooseItems, setChooseItems)

  const actions = useMemo(
    () => [
      {
        btnTitle: 'Добавить категорию',
        btnIco: 'add',
        onClick: () =>
          setOpenCreatePopup((prevState) => ({ ...prevState, active: true })),
        color: AppBtnColor.whiteOutlineViolet,
      },
    ],
    [],
  )

  const tableActions = [
    {
      title: 'Удалить',
      ico: 'basket',
      onClick: onDeletePopupHandler,
    },
    ...(process.env.REACT_APP_TYPE_SERVER === 'MainServer'
      ? [
          {
            title: 'Отправить на станцию',
            ico: 'add',
            onClick: openSentPopup,
          },
        ]
      : []),
  ]

  const openEditPopupHandler = useCallback(
    (id: number) => setOpenCreatePopup({ id, active: true }),
    [],
  )

  const closePopupHandler = useCallback(
    () => setOpenCreatePopup({ id: null, active: false }),
    [],
  )

  if (!category && isLoadingGet) {
    return <AppLoader loaderType={LoaderType.main} />
  }

  if (!category) {
    return null
  }

  return (
    <React.Fragment>
      {openCreatePopup.active && (
        <AddCategoryPopup
          closePopup={closePopupHandler}
          id={openCreatePopup.id}
        />
      )}
      {deletePopup && (
        <AppDeleteFromMainServerPopup
          onClose={closeDeletePopup}
          onDelete={onDeleteHandler}
          onOpenStationPopup={openDeleteStationPopup}
        />
      )}
      {sentPopup && (
        <AppStationPopup
          onClose={closeSentPopup}
          isLoading={isLoadingSend}
          onSendItems={onSendCategories}
          isDeleteMode={isDeleteMode}
          deleteStations={deleteStations}
          onDeleteStationDishes={onDeleteStation}
        />
      )}
      <div className="width-for-page-wrapper">
        <AppTitlePage title="Категории блюд" actions={actions} />
        <div className="col-7-width-from-1000">
          <div className="filter-block no-wrap mt-20">
            <AppFilterInput
              fullWidth
              searchParam={'search'}
              ico={'search'}
              label={'Поиск'}
              placeholder="Например: Холодный цех"
            />
            <AppFilterEdgeServersList fullWidth />
          </div>
          <AppTable
            idName="categories"
            data={category}
            headerData={headerData}
            chooseItems={chooseItems}
            chooseMode
            setChooseItems={setChooseItems}
            setTableData={setTableData}
            tableDataSelectors={[
              {
                renderItem: (item) => (
                  <div
                    className={`table-link${
                      item.archived ? ' delete-item' : ''
                    }`}
                    onClick={() => openEditPopupHandler(item.id)}
                  >
                    {item.name}
                  </div>
                ),
              },
            ]}
            chooseActions={tableActions}
            isLoading={isLoadingGet || isFetchingGet}
          />
        </div>
      </div>
    </React.Fragment>
  )
}
